.toolbar {
  display: flex;
  margin-bottom: 1px;
  background: white;
  vertical-align: middle;
  overflow: auto;
}

.toolbar > button {
  border: 0;
  display: flex;
  background: none;
  padding: 8px;
  cursor: pointer;
  vertical-align: middle;
}

.toolbar > button:disabled {
  cursor: not-allowed;
}

.toolbar > button:hover:not([disabled]) {
  background-color: #eee;
}

.dropdown-more {
  background-image: url("../images/dropdown-more.svg");
}

.plus {
  background-image: url("../images/plus.svg");
}

.bg-color {
  background-image: url("../images/bg-color.svg");
}

.font-color {
  background-image: url("../images/font-color.svg");
}

.table {
  background-image: url("../images/table.svg");
}

.horizontal-rule {
  background-image: url("../images/horizontal-rule.svg");
}
